import React from 'react';
import { Shield, Zap, Globe, Brain } from 'lucide-react';

const pillars = [
  { icon: <Brain size={20} />, title: 'AI-First Thinking', desc: 'Every solution we build considers AI augmentation from day one.' },
  { icon: <Globe size={20} />, title: 'Cloud Native', desc: 'Architected for scale on AWS, Azure, and GCP from the ground up.' },
  { icon: <Zap size={20} />, title: 'Rapid Delivery', desc: 'Agile sprints, CI/CD pipelines, and zero-compromise quality.' },
  { icon: <Shield size={20} />, title: 'Enterprise Security', desc: 'SOC2-aligned practices, encrypted at rest and in transit.' },
];

export default function About() {
  return (
    <section id="about" style={{ padding: '7rem 0', background: 'var(--bg-secondary)', position: 'relative', overflow: 'hidden' }}>
      <div className="glow-orb" style={{
        width: '500px', height: '500px',
        background: 'radial-gradient(circle, rgba(37,138,203,0.08) 0%, transparent 70%)',
        top: '50%', right: '-100px', transform: 'translateY(-50%)',
      }} />

      <div className="container">
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          gap: '5rem', alignItems: 'center',
        }} className="about-grid">
          {/* Left */}
          <div>
            <div className="section-label">
              <span>◆</span> About Nuage
            </div>
            <h2 className="section-heading">
              We build the <span className="gradient-text">digital backbone</span> of tomorrow's enterprises
            </h2>
            <p className="section-subtext" style={{ marginBottom: '1.5rem' }}>
              Nuage is a cloud-first technology consulting firm specializing in building scalable digital products, 
              intelligent AI systems, and robust cloud infrastructure for startups, scale-ups, and enterprises.
            </p>
            <p style={{ fontSize: '1rem', color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: '2rem' }}>
              Founded by engineers who've shipped real products at scale, we bring hands-on expertise in modern 
              web, mobile, DevOps, and cutting-edge AI — not just theory, but battle-tested solutions that move 
              the needle for your business.
            </p>
            <a href="#contact" className="btn-primary">
              Start a Conversation →
            </a>
          </div>

          {/* Right: pillars */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
            {pillars.map(p => (
              <div key={p.title} className="glass-card" style={{ padding: '1.5rem' }}>
                <div style={{
                  width: '44px', height: '44px', borderRadius: '10px',
                  background: 'rgba(37,138,203,0.12)', border: '1px solid rgba(37,138,203,0.2)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--accent)', marginBottom: '1rem',
                }}>
                  {p.icon}
                </div>
                <h4 style={{ fontFamily: 'var(--font-display)', fontSize: '0.95rem', fontWeight: 700, marginBottom: '0.4rem' }}>
                  {p.title}
                </h4>
                <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: 1.6 }}>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .about-grid { grid-template-columns: 1fr !important; gap: 3rem !important; }
        }
      `}</style>
    </section>
  );
}
